<template>
  <div class="container">
    <div class="action-part">
      <el-button size="medium" type="primary" @click="showEditor(null)">创建APP更新记录</el-button>
    </div>
    <div class="content-list">
      <el-table
          :data="resultList"
          border
          style="width: 100%">
        <el-table-column
            align="center"
            label="APP名称"
            prop="name"
            width="250">
        </el-table-column>
        <el-table-column
            align="center"
            label="安卓最新版本"
            prop="androidLatestVersion"
            width="180">
        </el-table-column>
        <el-table-column
            align="center"
            label="安卓系统版本"
            prop="androidLevel"
            width="180">
        </el-table-column>
        <el-table-column
            align="center"
            label="IOS最新版本"
            prop="iosLatestVersion"
            width="180">
        </el-table-column>
        <el-table-column
            align="center"
            label="IOS系统版本"
            prop="iosLevel"
            width="180">
        </el-table-column>
        <el-table-column
            align="center"
            label="安卓安装包链接"
            prop="androidDownloadUrl"
            width="">
        </el-table-column>
        <el-table-column
            header-align="center"
            label="更新内容"
            prop="updatedContent">
        </el-table-column>
      </el-table>
    </div>

    <div class="dialog-part">
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          :title="dialogText"
          :visible.sync="isEditorShow"
          center
          width="600px">
        <div class="dialog-content">
          <el-form :inline="true" size="medium" label-width="150px">
            <el-form-item :required="true" label="名称">
              <el-input v-model="appUpgrade.name" placeholder="请输入APP名称"></el-input>
            </el-form-item>
            <el-form-item :required="true" label="安卓安装包版本号">
              <el-input-number :min="1" v-model="appUpgrade.androidLatestVersion" placeholder="请输入安装包版本号"></el-input-number>
            </el-form-item>
            <el-form-item :required="true" label="安卓系统版本">
              <el-select v-model="appUpgrade.androidLevel" placeholder="请选择安卓系统版本号">
                <el-option
                    v-for="item in androidLevelList"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :required="true" label="IOS安装包版本号">
              <el-input-number :min="1" v-model="appUpgrade.iosLatestVersion" placeholder="请输入安装包版本号"></el-input-number>
            </el-form-item>
            <el-form-item :required="true" label="IOS系统版本">
<!--              <el-input v-model="appUpgrade.iosLevel" placeholder="请输入IOS系统版本号"></el-input>-->
              <el-select v-model="appUpgrade.iosLevel" placeholder="请选择IOS系统版本号">
                <el-option
                    v-for="item in iosLevelList"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :required="true" label="更新描述">
              <el-input v-model="appUpgrade.updatedContent" placeholder="请输入更新描述"></el-input>
            </el-form-item>
            <el-form-item :required="true" label="安卓安装包">
              <el-upload
                  ref="importUpload"
                  :auto-upload="true"
                  name="app"
                  :file-list="androidUploadFile"
                  :timeout="300000"
                  :before-upload="beforeUpload"
                  :on-change="onFileChange"
                  :on-success="onUploadSuccess"
                  :with-credentials="true"
                  accept=".apk"
                  :action="uploadFilePath"
                  :limit="1">
                <el-button size="small" type="primary">{{ uploadText }}</el-button>
                <div slot="tip" class="el-upload__tip">只能上传.apk文件，且不超过300M</div>
              </el-upload>
            </el-form-item>
<!--            <el-form-item :required="true" label="苹果安装包">-->
<!--              <el-upload-->
<!--                  ref="importUpload"-->
<!--                  :auto-upload="true"-->
<!--                  name="app"-->
<!--                  :file-list="iosUploadFile"-->
<!--                  :timeout="300000"-->
<!--                  :on-change="onFileChange2"-->
<!--                  :on-success="onUploadSuccess2"-->
<!--                  :with-credentials="true"-->
<!--                  accept=".apk"-->
<!--                  :action="uploadFilePath"-->
<!--                  :limit="1">-->
<!--                <el-button size="small" type="primary">{{ uploadText }}</el-button>-->
<!--                <div slot="tip" class="el-upload__tip">只能上传.apk文件，且不超过300M</div>-->
<!--              </el-upload>-->
<!--            </el-form-item>-->
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
           <el-button size="medium" @click="onEditorCancel">取 消</el-button>
           <el-button size="medium" type="primary" :disabled="btnDisable" @click="onEditorConfirm">提 交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script lang="ts">
import * as api from '@/api/api'

export default {
  name: 'AppUpgrade',
  data() {
    return {
      name: 'AppUpgrade',
      appUpgrade: {
        id: "",
        name: "超田APP",
        androidLatestVersion: "",
        androidLevel: "",
        iosLatestVersion: "",
        iosLevel: "",
        androidDownloadUrl: "",
        iosDownloadUrl: "",
        skipUrl: "",
        forceUpgrade: 0,
        updatedContent: "修复已知问题!",
      },
      uploadFilePath: '',
      uploadText: '上传文件',

      androidUploadFile: [],
      iosUploadFile: [],

      // 提交按钮是否可用
      btnDisable: false,
      isEditorShow: false,
      dialogText: '',
      resultList: [],
      // 把下面的版本号列表倒序
      androidLevelList: [
          'Android 1.0',
          'Android 2.0',
          'Android 3.0',
          'Android 4.0',
          'Android 5.0',
          'Android 6.0',
          'Android 7.0',
          'Android 8.0',
          'Android 9',
          'Android 10',
          'Android 11',
          'Android 12',
          'Android 13',
          'Android 14',
          'Android 15',
          'Android 16',
      ].reverse(),
      iosLevelList: [
          'iPhone OS 1',
          'iPhone OS 2',
          'iPhone OS 3',
          'iOS 4',
          'iOS 5',
          'iOS 6',
          'iOS 7',
          'iOS 8',
          'iOS 9',
          'iOS 10',
          'iOS 11',
          'iOS 12',
          'iOS 13',
          'iOS 14',
          'iOS 15',
          'iOS 16',
          'iOS 17',
          'iOS 18',
      ].reverse()
    }
  },
  methods: {
    showEditor(item) {
      if (item) {
        this.dialogText = '编辑';
      } else {
        this.dialogText = '创建';
      }
      this.isEditorShow = true;
    },
    listContent() {
      api.listAppUpgrade().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.resultList = result.data;
        }
      })
    },

    onEditorCancel() {
      this.appUpgrade.name = "超田教育APP";
      this.appUpgrade.androidLatestVersion = "";
      this.appUpgrade.androidLevel = "";
      this.appUpgrade.iosLatestVersion = "";
      this.appUpgrade.iosLevel = "";
      this.appUpgrade.androidDownloadUrl = "";
      this.appUpgrade.iosDownloadUrl = "";
      this.appUpgrade.skipUrl = "";
      this.appUpgrade.forceUpgrade = 0;
      this.appUpgrade.updatedContent = "";
      this.isEditorShow = false;
    },

    onEditorConfirm() {
      if (this.appUpgrade.name === '') {
        return this.$message.error("请填写故事标题.");
      }

      console.log("this.appUpgrade", this.appUpgrade)

      api.addAppUpgrade(this.appUpgrade).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success(result.msg);
          this.listContent();
          this.onEditorCancel();
        } else {
          this.$message.error(result.msg);
        }
      })
    },

    beforeUpload(file) {
      this.btnDisable = true;
      console.log(file.name)
    },
    onFileChange(file) {
      console.log(file.name)
    },
    onUploadSuccess(result) {
      console.log("上传完成")
      if (result.code === api.SUCCESS_CODE) {
        this.$message.success(result.msg);
        this.appUpgrade.androidDownloadUrl = result.data.path;
        this.btnDisable = false;
      } else {
        this.$message.error(result.msg);
      }
      this.btnDisable = false;
    },

    onFileChange2(file) {
      console.log(file.name)
    },
    onUploadSuccess2(result) {
      if (result.code === api.SUCCESS_CODE) {
        this.$message.success(result.msg);
        this.appUpgrade.iosDownloadUrl = result.data;
      } else {
        this.$message.error(result.msg);
      }
    },
  },
  mounted() {
    // 处理mp3上传地址，拼接上token信息
    const token = this.$store.state.user.token;
    this.uploadFilePath = api.baseUrl + `/md/file/app?ct-sob-admin-token=${token}`

    this.listContent()


  }
}
</script>

<script lang="ts" setup></script>

<style lang="scss" scoped></style>
